<template>
  <v2-row noSpace>
    <v2-col col12 noSpaceX noSpace>
      <v2-redactor
        :label="$t('quickLaunch.labels.content')"
        :placeholder="$t('forms.required')"
        minHeight="300px"
        v-model="text"
        v-validate="'required'"
        name="content"
        @input="setChangedComp()"
        :config="redactorCustomConfig"
        :error="errors.first('content')"
        :data-vv-as="$t('quickLaunch.labels.content')"
      />
    </v2-col>
    <v2-col col12 class="items-end" noSpaceX noSpace>
      <v2-button outline primary @click.native="saveComponent(false)">{{ $t("quickLaunch.actions.save") }}</v2-button>
    </v2-col>
  </v2-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import variablesDropdown from "@envivo/backoffice-components/_base_v2/inputs/redactor/redactorPlugins/variablesDropdown";
import { tablePlugin, tableClass } from "@envivo/backoffice-components/_base_v2/inputs/redactor/redactorPlugins/table";

export default {
  name: "QuickLaunchHtml",
  props: {
    component: Object,
  },
  data() {
    return {
      hasChanged: false,
      text: "",
      redactorCustomConfig: {
        plugins: ["variablesDropdown", "table"],
        variables: [
          {
            title: "owner_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${owner:first_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
          {
            title: "owner_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${owner:last_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
          {
            title: "contact_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:first_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
          {
            title: "contact_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:last_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
        ],
      },
    };
  },
  created() {
    this.text = this.component.value.textContent;
    window.Redactor.add("plugin", "variablesDropdown", variablesDropdown);
    if (this.editorTableIsEnabled) {
      window.Redactor.add("plugin", "table", tablePlugin);
      window.Redactor.add("class", "table.component", tableClass);
    }
    this.$eventbus.$on("saveComponents", () => {
      this.saveComponent(true);
    });
  },
  methods: {
    ...mapActions(["updateComponent", "getProjectComponent"]),
    setChangedComp() {
      this.hasChanged = true;
      this.$eventbus.$emit("setUnsavedComponents", this.component.uid);
    },
    saveComponent(isEvent = false) {
      if (this.hasChanged) {
        const vm = this;
        const data = {
          customLoading: true,
          params: {
            project: vm.currentProject.uid,
            component: vm.component.uid,
          },
          data: {
            value: {
              textContent: vm.text ? this.$base64.encode(vm.text) : vm.text,
            },
            encoded: ["textContent"],
          },
        };
        vm.$validator.validateAll().then((result) => {
          if (result) {
            vm.updateComponent(data)
              .then(() => {
                vm.$eventbus.$emit("componentSavedSuccess", this.component.uid, isEvent);
                vm.hasChanged = false;
                if (!isEvent) {
                  vm.$snotify.success(vm.$t("quickLaunch.toasts.saveComponent.success"), vm.$t("toasts.success"), {
                    icon: vm.$successIcon,
                  });
                  vm.reloadComponent();
                }
              })
              .catch(() => {
                vm.$eventbus.$emit("componentSavedError", this.component.uid);
                if (!isEvent) {
                  vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.error"), vm.$t("toasts.error"), {
                    timeout: 0,
                    icon: vm.$errorIcon,
                  });
                }
              });
          } else {
            vm.$eventbus.$emit("componentSavedError", this.component.uid);
            if (!isEvent) {
              vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            }
          }
        });
      }
    },
    reloadComponent() {
      this.getProjectComponent({
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.component.uid,
        },
      }).then(() => {});
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentProject: "projects_get_current_project",
    }),
    editorTableIsEnabled() {
      return this.teams[this.$route.params.team].account.team.attributes.editor_table_enabled;
    },
  },
};
</script>

<style lang="scss"></style>
